import { render, staticRenderFns } from "./PuertasModal.vue?vue&type=template&id=1e8c0a5e"
import script from "./PuertasModal.vue?vue&type=script&lang=js"
export * from "./PuertasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports